import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { AssetShipment } from './asset-shipment';


export class AssetShipmentAsset extends BaseEntity {

  assetShipment     : AssetShipment;
  asset             : Asset;
  progressLevel     : number;


  constructor() {
    super();

  }
}

	
